module.exports = __webpack_public_path__ + "static/media/golgi.9aeef952.mp3";